import React from "react";
import {
  FaExclamationTriangle,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

// Define props interface
interface BannerProps {
  type: "success" | "warning" | "danger"; // Type of banner
  header: string; // Header text for the banner
  body: string; // Main body text
}

// Function to determine the background, text color, and icon based on banner type
const getBannerStyles = (type: "success" | "warning" | "danger") => {
  switch (type) {
    case "success":
      return {
        backgroundColor: "#28a745", // Green for success
        color: "#fff", // White text
        icon: <FaCheckCircle />, // Success icon
      };
    case "warning":
      return {
        backgroundColor: "#ffcc00", // Yellow for warning
        color: "#333", // Dark text
        icon: <FaExclamationTriangle />, // Warning icon
      };
    case "danger":
      return {
        backgroundColor: "#dc3545", // Red for danger
        color: "#fff", // White text
        icon: <FaTimesCircle />, // Danger icon
      };
    default:
      return {
        backgroundColor: "#ffcc00", // Default to yellow (warning)
        color: "#333",
        icon: <FaExclamationTriangle />,
      };
  }
};

const Banner: React.FC<BannerProps> = ({ type, header, body }) => {
  const { backgroundColor, color, icon } = getBannerStyles(type);

  // Banner style
  const bannerStyle = {
    display: "flex",
    alignItems: "center",
    backgroundColor: backgroundColor, // Background color based on type
    color: color, // Text color based on type
    padding: "10px 20px",
    borderRadius: "5px",
    fontSize: "16px",
    fontWeight: "bold",
    width: "100%",
    maxWidth: "600px",
    margin: "10px auto", // Center it horizontally with some margin
  };

  // Icon style
  const iconStyle = {
    marginRight: "10px", // Space between the icon and the text
    fontSize: "20px", // Icon size
  };

  return (
    <div style={bannerStyle}>
      <div style={iconStyle}>{icon}</div>
      <div>
        <b>{header}</b>
        <p>{body}</p>
      </div>
    </div>
  );
};

export default Banner;
